import http from 'src/app/http';


const getIsLoggedIn = () => http.get('/isLoggedIn');

export default { getIsLoggedIn };
